module.exports = __webpack_public_path__ + "static/media/FinalCase_KY.552c4415.jpg";